import styled, { keyframes } from 'styled-components'

import { theme } from '@dasa-health/components-react'
import CustomTheme from 'theme'

const rotation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.primary};
    display: flex;
    flex-direction: column;
`

export const TextWrapper = styled.div`
    flex: 1 0 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
    text-align: center;
    max-width: 272px;

    ${CustomTheme.breakPoint.tablet} {
        max-width: none;
    }

    h1 {
        font-size: 2.5rem;
    }

    h2 {
        font-weight: 400;

        ${CustomTheme.breakPoint.tablet} {
            max-width: 450px;

            br {
                display: none;
            }
        }
    }
`

export const IllustrationWrapper = styled.div`
    flex: 1 0 50%;
`

export const Illustration = styled.div`
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;

    ${CustomTheme.breakPoint.tablet} {
        background-size: contain;
    }

    ${CustomTheme.breakPoint.desktop} {
        background-size: 40% auto;
    }
`
export const IconSpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    animation: ${rotation} 1s linear infinite;

    > svg {
        font-size: 30px;

        > path {
            stroke: ${theme.colors.white};
            stroke-width: 2;
        }
    }
`
